<template>
  <r-item custom-class="beneficiary-option">
    <slot/>
  </r-item>
</template>

<script>
import RItem from '@/components/base/RItem';

export default {
  name: 'BeneficiaryOption',
  components: { RItem },
};
</script>

<style scoped lang="scss">

.beneficiary-option {
  padding: 10px 0;
}

</style>
